import {
  capitalize,
  FormControl,
  FormLabel,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import { FormTextField } from './formTextField';

export const CustomAccountDisplayName = ({
  entityName,
  customName,
  setCustomName,
}: {
  entityName: string;
  customName: string;
  setCustomName: (name: string) => void;
}) => {
  const [useCustomName, setUseCustomName] = useState(false);
  return (
    <FormControl>
      <FormLabel sx={{ width: '100%' }}>
        <Typography variant='subtitle1'>{`${capitalize(entityName)} display name in Eon`}</Typography>
      </FormLabel>
      <Stack gap='24px'>
        <ToggleButtonGroup
          sx={{ width: 'max-content' }}
          exclusive
          value={useCustomName}
          onChange={(_, value) => {
            setUseCustomName(value);
          }}
        >
          <ToggleButton value={false}>Use {entityName} name</ToggleButton>
          <ToggleButton value={true}>Customize</ToggleButton>
        </ToggleButtonGroup>
        {useCustomName && (
          <FormTextField
            title='Custom display name'
            placeholder='Example: production'
            value={customName}
            onChange={(event) => setCustomName(event.target.value)}
          />
        )}
      </Stack>
    </FormControl>
  );
};
